<template>
  <div>
    <Breacrumb :links="breadCrumbData" />
    <h4 class="antecedente-content">Antecedentes para la Declaración</h4>
    <Main />
  </div>
</template>
<script>
import Breacrumb from "@/components/tools/Breadcrumb.vue";
import Main from "./Main.vue";
import { mapState } from "vuex";
export default {
  components: {
    Breacrumb,
    Main,
  },
  computed: {
    ...mapState("sesion", ["usuario"]),

  },
  data() {
    return {
      breadCrumbData: null,
    };
  },
  methods: {
    setBreadcrumbData: function() {
      // if (!this.usuario) return;
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Antecedentes para la Declaración",
          routeName: "antecedente",
          routeParams: {
            // ...this.$route.params,
          },
        },
      ];
    },
  },
  mounted() {
    this.setBreadcrumbData();
  }
};
</script>

<style scoped>
.antecedente-content {
  text-align: center;
}
</style>
